import React, { useEffect, useState } from 'react';
import { Container, Form, InputGroup, Nav } from 'react-bootstrap';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import './ContractsLayout.css';

const NAV_ITEMS = [
  { path: '/contracts', label: 'Contracts', end: false },
  { path: '/contracts/unsorted', label: 'Pending Uploads', end: true }
];

const ContractsLayout = ({ children }) => {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchInput, setSearchInput] = useState(() => searchParams.get('q') || '');

  const showSearch =
    location.pathname === '/contracts'
    || location.pathname.startsWith('/contracts/unsorted');

  useEffect(() => {
    setSearchInput(searchParams.get('q') || '');
  }, [location.pathname, searchParams]);

  useEffect(() => {
    if (!showSearch) {
      return undefined;
    }
    const timer = window.setTimeout(() => {
      const next = searchInput.trim();
      const current = searchParams.get('q') || '';
      if (next === current) {
        return;
      }
      const params = new URLSearchParams(searchParams);
      if (next) {
        params.set('q', next);
      } else {
        params.delete('q');
      }
      setSearchParams(params, { replace: true });
    }, 300);
    return () => window.clearTimeout(timer);
  }, [searchInput, showSearch, searchParams, setSearchParams]);

  const isActive = (path, end) => {
    if (path === '/contracts' && !end) {
      return location.pathname === '/contracts'
        || (location.pathname.startsWith('/contracts/')
          && !location.pathname.startsWith('/contracts/unsorted'));
    }
    if (end) {
      return location.pathname === path || location.pathname === `${path}/`;
    }
    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };

  const navLinkTo = (path) => {
    const q = searchParams.get('q');
    return q ? `${path}?q=${encodeURIComponent(q)}` : path;
  };

  return (
    <Container fluid className="py-3 contracts-layout">
      <Nav variant="pills" className="contracts-subnav flex-wrap gap-1 mb-3">
        {NAV_ITEMS.map((item) => (
          <Nav.Item key={item.path}>
            <Nav.Link
              as={Link}
              to={navLinkTo(item.path)}
              active={isActive(item.path, item.end)}
            >
              {item.label}
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
      {showSearch && (
        <InputGroup className="mb-3 contracts-search">
          <InputGroup.Text>
            <i className="fas fa-search" aria-hidden="true" />
          </InputGroup.Text>
          <Form.Control
            type="search"
            placeholder="Search name, site, notes, file name…"
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            aria-label="Search contracts"
          />
        </InputGroup>
      )}
      {children}
    </Container>
  );
};

export default ContractsLayout;
